import PropTypes from 'prop-types'

import Modal from 'components/Modal'
import Select from 'components/Select'

const MobileFilters = ({
  onCloseModal,
  handleSetFilter,
  revenueCenterFilterValue,
  transformedRevenueCenters,
}) => {
  return (
    <Modal
      title="Filters"
      onClose={onCloseModal}
      className="-spacing-top"
      overlayClassName="-overlay-background-none"
    >
      <div className="mobile-filters">
        <Select
          id="revenueCenter"
          handleChange={handleSetFilter('revenueCenterUuid')}
          nameClass="-medium"
          label="All Revenue Centers"
          defaultValue={revenueCenterFilterValue}
          options={transformedRevenueCenters}
        />
      </div>
    </Modal>
  )
}

MobileFilters.propTypes = {
  onCloseModal: PropTypes.func,
  handleSetFilter: PropTypes.func,
  revenueCenterFilterValue: PropTypes.string,
  transformedRevenueCenters: PropTypes.array,
}

export default MobileFilters
